import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TitoloEsecutivo } from '../../../models/titolo-esecutivo';

@Component({
    selector: '[add_doc_to_titolo]',
  templateUrl: 'add-to-titolo-esecutivo.component.html',
})

export class AddDocumentoToTitoloEsecutivoComponent {
  @Input()
  titolo: TitoloEsecutivo;

  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(titoloEsecutivo: TitoloEsecutivo) {
    this.onClickAddToEntity.emit(titoloEsecutivo);
  }
}
